import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CART_URL } from "../data/offer";
import { handleCheckoutClick } from "../utils/metaPixel";
type CtaButtonProps = {
  children: React.ReactNode;
  size?: "md" | "lg";
  fullWidth?: boolean;
};
export function CtaButton({
  children,
  size = "lg",
  fullWidth = false
}: CtaButtonProps) {
  const sizing = size === "lg" ? "px-6 py-4 text-base sm:px-8 sm:py-5 md:text-lg" : "px-5 py-3.5 text-sm sm:px-6 md:text-base";
  return <a href={CART_URL} onClick={handleCheckoutClick} className={`group inline-flex items-center justify-center max-w-full gap-3 text-center rounded-full sm:whitespace-nowrap bg-sun font-extrabold text-ink shadow-[0_6px_0_0_#B88A00] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-sun-dark hover:shadow-[0_8px_0_0_#B88A00] active:translate-y-1 active:shadow-[0_2px_0_0_#B88A00] focus:outline-none focus-visible:ring-4 focus-visible:ring-sun/50 ${sizing} ${fullWidth ? "w-full" : ""}`} data-id="element-102" data-mp="lm0kst1udz78">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-103" data-mp="39yholr1zvndu" />
    </a>;
}